import { urls } from "../config";
import { AxiosInstancePrivate } from "../utils/AxiosInstance";
import { GTM_EVENTS } from "../utils/constants";

const privateAxios = AxiosInstancePrivate();

export const getVgsapSearchCriteria = async (startDate, endDate, term) => {
	const params = {};
	if (startDate) params.startDate = startDate;
	if (endDate) params.endDate = endDate;
	// When a term is provided the Sales News No / Promo No lists are searched
	// across ALL records (server ignores the date range for that lookup).
	if (term) params.term = term;
	const response = await privateAxios.get(urls.salesNewsVgsapCriteria, { params });
	return response?.data;
};

export const getVgsapSearchResults = async (pagination, sortModel, searchData, pushToDL) => {
	// when sorting using sales news no column, field name by default will be numberAndLink 
	// So it must be changed to field name matching with backend database
	if(sortModel[0]?.field === "numberAndLink") {
		sortModel = structuredClone(sortModel) // deep copy to prevent original arr modification
		sortModel[0].field = "bulletin_no"
	}

	const response = await privateAxios.post(urls.salesNewsVgsapSearchResults, {pagination, sortModel, ...searchData});

	pushToDL?.(GTM_EVENTS.SEARCH_SUBMIT, {
		button_text: 'search',
		search_criteria: searchData,
	})
	return response?.data;
};

export const downloadAllVgsapResult = async (
	sortModel, searchData, download,
	emails, selectedIds, pushToDL
) => {
	try {
		// when sorting using sales news no column, field name by default will be numberAndLink 
		// So it must be changed to field name matching with backend database
		if(sortModel[0]?.field === "numberAndLink") {
			sortModel = structuredClone(sortModel) // deep copy to prevent original arr modification
			sortModel[0].field = "bulletin_no"
		}

		const response = await privateAxios.post(urls.salesNewsVgsapDownloadAll, {
			sortModel, ...searchData, download, emails, selectedIds
		}, { timeout: 55000 }); // 55s timeout to stay within API Gateway limits
		if(download){
			pushToDL?.(GTM_EVENTS.EMAIL_ME, {
				button_text: 'Email * Files (PDF)',
				bulletins: selectedIds,
			})
		}
		return response?.data;
	} catch (error) {
		console.error('Error in getting all VGSAP SalesNews Result ->', error);
		throw error;
	}
};

export const downloadVgsapBulletinPDF = async (bulletinNumbers, pushToDL) => {
	const response = await privateAxios.post(urls.salesNewsVgsapDownloadPDF, {bulletinNumbers});
	pushToDL?.(GTM_EVENTS.DOWNLOAD, {
		button_text: 'Download * Files (PDF)',
		bulletins: bulletinNumbers,
	})

	// Handle new response format with warning support
	const data = response?.data;
	if (data && typeof data === 'object' && 'url' in data) {
		// Return full response object so callers can show warning as toast
		if (!data.url) {
			return { url: null, warning: data.warning || null };
		}
		return { url: data.url, warning: data.warning || null };
	}

	// Backward compatibility — plain URL string
	return { url: data, warning: null };
};

export const getVgsapBulletinDetail = async (bulletinNo) => {
	const response = await privateAxios.get(urls.salesNewsVgsapBulletinDetail, { params: { bulletinNo } });
	return response?.data;
};

export const getVgsapBulletinModels = async (bulletinNo) => {
	const response = await privateAxios.get(urls.salesNewsVgsapBulletinModels, { params: { bulletinNo } });
	return response?.data;
};

export const getVgsapBulletinViewData = async (bulletinNo, queryType) => {
	const response = await privateAxios.get(urls.salesNewsVgsapBulletinViewData, { params: { bulletinNo, queryType } });
	return response?.data;
};

export const getVgsapReport = async (scdCode, startDate, endDate, page = 0, pageSize = 100) => {
	const params = {};
	if (scdCode) params.scdCode = scdCode;
	if (startDate) params.startDate = startDate;
	if (endDate) params.endDate = endDate;
	params.page = page;
	params.pageSize = pageSize;
	const response = await privateAxios.get(urls.salesNewsVgsapReport, { params });
	return response?.data;
};

export const getVgsapPromotionDetail = async (promoId) => {
	const response = await privateAxios.get(urls.salesNewsVgsapPromotionDetail, { params: { promoId } });
	return response?.data;
};

export const getVgsapPromotionSummary = async (promoIds) => {
	const response = await privateAxios.post(urls.salesNewsVgsapPromotionSummary, { promoIds });
	return response?.data;
};

export const getVgsapCpgData = async () => {
	const response = await privateAxios.get(urls.salesNewsVgsapCpgData);
	return response?.data;
};

export const updateVgsapPromotion = async (data) => {
	const response = await privateAxios.post(urls.salesNewsVgsapPromotionUpdate, data);
	return response?.data;
};

export const getVgsapReportPromotions = async (scdCode, startDate, endDate) => {
	const params = {};
	if (scdCode) params.scdCode = scdCode;
	if (startDate) params.startDate = startDate;
	if (endDate) params.endDate = endDate;
	const response = await privateAxios.get(urls.salesNewsVgsapReportPromotions, { params });
	return response?.data;
};

